import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { STATUS, useRequiredRetailerIntegrationConfig } from '../../../hooks/useRequiredRetailerIntegrationConfig';
import { RetailerIntegrationConfigurationPage } from '../../integrations/RetailerIntegrationConfigurationPage';

import styles from './PageLayout.module.scss';

function PageLayout(props) {
  const { top, children } = props;
  const { retailerIntegrationConfigStatus, integrationType } = useRequiredRetailerIntegrationConfig();

  return (
    <>
      {top && retailerIntegrationConfigStatus === STATUS.OK && <div className={styles.topContainer}>{top}</div>}

      <div className={cn('container-fluid', styles.pageContainer)}>
        {retailerIntegrationConfigStatus === STATUS.MISSING ? (
          <RetailerIntegrationConfigurationPage type={integrationType} />
        ) : (
          children
        )}
      </div>
    </>
  );
}

export default PageLayout;

PageLayout.propTypes = {
  top: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};
